import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import axios from "axios";
import './OperatProf.css'
import { IMG_SERVER_URL } from "../../../ServerUrl";


function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "50%", background: "#85245f" }}
            onClick={onClick}
        >
            <FaAngleRight className="rightArrowSlider" />
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "flex", justifyContent: "center", alignItems: "center", background: "#85245f", borderRadius: "50%", }}
            onClick={onClick}
        >
            <FaAngleLeft className="rightArrowSlider" />
        </div>
    );
}


const OperatorPicturesSlider = ({ operator }) => {
    const [selectedImage, setSelectedImage] = useState(null);



    var settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    infinite: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <>
            <Slider {...settings}>
                {operator?.images?.map((image, index) => (
                    <div key={index} className="operatorSliderImageOuter"
                        style={{ cursor: "pointer" }}
                    >
                        <img src={`${IMG_SERVER_URL}/${image}`} onClick={() => setSelectedImage(image)} className="operatorDetailImg" />
                    </div>
                ))}
            </Slider>
            {selectedImage && (
                <div className="modal-overlay-profile" onClick={() => setSelectedImage(null)}>
                    <div className="modal-content-profile">
                        <img src={`${IMG_SERVER_URL}/${selectedImage}`} alt="Enlarged View" className="modal-content-profile-img" />
                        <button className="close-btn-profile" onClick={() => setSelectedImage(null)}>✖</button>
                    </div>

                </div>
            )}
        </>
    )
}

export default OperatorPicturesSlider
